module.exports = __webpack_public_path__ + "app-static/img/image1.007031c7.png";